import { render, staticRenderFns } from "./FormAuthCheckPhone.vue?vue&type=template&id=bb1e6f30&scoped=true&"
import script from "./FormAuthCheckPhone.vue?vue&type=script&lang=js&"
export * from "./FormAuthCheckPhone.vue?vue&type=script&lang=js&"
import style0 from "./FormAuthCheckPhone.vue?vue&type=style&index=0&id=bb1e6f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1e6f30",
  null
  
)

export default component.exports